// extracted by mini-css-extract-plugin
export var mobileSearch = "MobileSearch-module--mobileSearch--b7fff";
export var popular = "MobileSearch-module--popular--95328";
export var searchActive = "MobileSearch-module--searchActive--226bb";
export var searchContent = "MobileSearch-module--searchContent--8c34f";
export var searchInput = "MobileSearch-module--searchInput--a0d36";
export var suggestions = "MobileSearch-module--suggestions--4f4fa";
export var visible = "MobileSearch-module--visible--cd4da";